(ns manage.adset-decision-tree-page.view.node-conversion
  (:require [cljs-bean.core :refer [->clj]]
            [clojure.string :as str]
            [linked.core :as linked]
            [manage.adset-decision-tree-page.node-library :as node-library]
            [mate.core :as mc]))

(def be-node-data-fields
  [:label :config :targeting :variants :ad-variants :parent-id :targeting-hash :warnings
   :immutable-id])

(defn- qualify-type [type]
  (when type
    (cond
      (string? type) (keyword node-library/node-type-ns type)
      (and (keyword? type) (not (namespace type)))
      (keyword node-library/node-type-ns (name type))
      :else type)))

(defn- node-type-name [node-type]
  (cond
    (string? node-type) node-type
    (keyword? node-type) (name node-type)
    :else (str node-type)))

(defn api-node-type [node-type]
  (when node-type
    (node-type-name (qualify-type node-type))))

(defn ->outcome-node [decision-node-type]
  (when-let [library-node (node-library/type->node (qualify-type decision-node-type))]
    (-> (:outcome-node-type library-node)
        node-library/type->node)))

(defn decision-node->outcome-node-type [decision-node-type]
  (some-> decision-node-type qualify-type ->outcome-node :type))

(defn ->decision-node [outcome-node-type]
  (when-let [library-node (node-library/type->node (qualify-type outcome-node-type))]
    (-> (:decision-node-type library-node)
        node-library/type->node)))

(defn ->edge [source target]
  (str source "->" target))

;; TODO: use outcome-node? and category instead
(defn outcome-type? [node-type]
  (-> node-type
      node-type-name
      (str/ends-with? "-outcome")))

(defn root-node-type? [node-type]
  (= (node-type-name node-type) "root"))

(defn outcome-node? [{:keys [category]}] (= category :outcome-node))
(defn root-node? [{:keys [category]}] (= category :root-node))

(defn generated-node? [{:keys [targeting-hash]}]
  (not= targeting-hash "00000000-0000-0000-0000-000000000000"))

(defn- ensure-clj-map [value]
  (if (map? value) value (->clj value)))

(defn get-base-node-data [be-node]
  (let [be-node (ensure-clj-map be-node)
        qualified-type (qualify-type (:type be-node))
        ordinal (-> be-node :visualization :ordinal)
        base (merge (or (node-library/type->node qualified-type) {})
                    (select-keys be-node be-node-data-fields))]
    (cond-> base
      qualified-type (assoc :type qualified-type)
      (some? ordinal) (assoc :ordinal ordinal))))

(defn rebuild-reactflow-edges [editor]
  (let [node-id->node-data (:node-id->node-data editor)]
    (-> editor
        ;; FIXME: this override properties like the edge's selection state.
        (assoc :reactflow-edges (into (linked/map)
                                      (keep (fn [{:keys [type parent-id id]}]
                                              ;; When it's a decision node, and it has a parent
                                              (when (and (not (outcome-type? type))
                                                         (some? parent-id))
                                                (let [edge-id (->edge parent-id id)]
                                                  [edge-id
                                                   (-> (merge {:id edge-id
                                                               :target (str id)}

                                                              ;; Grandparent is a decision node if the parent is an outcome
                                                              ;; or nil if the parent is the starting node
                                                              (if-some [grandparent-id (-> parent-id node-id->node-data :parent-id)]
                                                                {:source (str grandparent-id)
                                                                 :sourceHandle (str parent-id)}
                                                                {:source (str parent-id)}))
                                                       clj->js)]))))
                                      (vals node-id->node-data))))))

(defn qualify-be-node-type [be-node]
  (update (ensure-clj-map be-node) :type qualify-type))

(defn qualify-be-node-types [be-nodes]
  (map qualify-be-node-type be-nodes))

(defn update-fe-nodes-from-be-nodes
  [editor be-nodes]
  (let [be-nodes (qualify-be-node-types be-nodes)]
    (-> editor
        (update :node-id->be-node into (mc/index-by :id be-nodes))
        (update :node-id->node-data (fn [node-id->node-data]
                                      (let [;; First, convert and add all the new nodes.
                                            node-id->node-data (into node-id->node-data
                                                                     (map (fn [be-node]
                                                                            (let [node-id (:id be-node)]
                                                                              [node-id (-> (get-base-node-data be-node)
                                                                                           (assoc :id node-id))])))
                                                                     be-nodes)

                                            ;; Then set the parent-child relations between them.
                                            node-id->node-data (reduce (fn [node-id->node-data {:keys [id parent-id]}]
                                                                         (cond
                                                                           (nil? parent-id)
                                                                           node-id->node-data

                                                                           (contains? node-id->node-data parent-id)
                                                                           (-> node-id->node-data
                                                                               (update-in [parent-id :outcome-node-ids] (fnil conj []) id))

                                                                           :else
                                                                           (do (js/console.warn (str "Orphan node found: Parent "
                                                                                                     parent-id " of node " id
                                                                                                     " does not exist."))
                                                                               node-id->node-data)))
                                                                       (update-vals node-id->node-data #(dissoc % :outcome-node-ids))
                                                                       (vals node-id->node-data))
                                            ;; All the outcome-node-ids in the same order as they are provided,
                                            ;; unless they have an :ordinal value in their :visualization
                                            node-id->node-data (update-vals node-id->node-data
                                                                            (fn [node]
                                                                              (cond-> node
                                                                                (:outcome-node-ids node)
                                                                                (update :outcome-node-ids
                                                                                        (fn [outcome-node-ids]
                                                                                          (->> outcome-node-ids
                                                                                               (sort-by (fn [outcome-node-id]
                                                                                                          (-> outcome-node-id
                                                                                                              node-id->node-data
                                                                                                              (:ordinal 9000))))
                                                                                               vec))))))]
                                        node-id->node-data)))
        (update :reactflow-nodes
                (fn [reactflow-nodes]
                  (->> be-nodes
                       (filter (comp not outcome-type? :type))
                       (map (fn [be-node]
                              (let [node-data (get-base-node-data be-node)
                                    reactflow-node
                                    (cond-> {:type (if (root-node-type? (:type be-node))
                                                     "decision-tree-root-node"
                                                     "decision-tree-decision-node")
                                             :id (str (:id be-node))
                                             :position #js {:x (-> be-node :visualization (:x 0))
                                                            :y (-> be-node :visualization (:y 0))}
                                             :deletable (:deletable node-data true)}
                                      (some? (:draggable node-data)) (assoc :draggable (:draggable node-data))
                                      true clj->js)]
                                [(:id be-node) reactflow-node])))
                       (into {})
                       (merge-with js/Object.assign reactflow-nodes)
                       (into (linked/map)))))
        (rebuild-reactflow-edges))))

(defn fe-node->be-node [reactflow-node node-data]
  (let [position (:position reactflow-node)]
    (-> (select-keys node-data (concat [:id :type] be-node-data-fields))
        (cond-> (some? position) (assoc :visualization position)))))
